import type { Achievement } from "../achievement.types";
import { allMoves, shareOf } from "../moveHistory";

export const againstTheGrainAchievement: Achievement = {
  id: "againstTheGrain",
  name: "Against the Grain",
  icon: "weather-windy",
  description: "Won choosing the least similar word half the time or more.",
  isProgressive: true,
  // Over every move made, backtracked ones included.
  // Rule unchanged from v1's Loose Cannon Wins (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) return false;
    const moves = allMoves(gameReport);
    if (moves.length === 0) return false;
    return shareOf(moves, (m) => m.choseLeastSimilarNeighbor === true) >= 0.5;
  },
};
